//Step 1: Redux Store Setup
//1.1 Store Configuration

// store/index.js
// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
//import ocxoReducer from './ocxoSlice';
import frontPageReducer from './frontPageSlice';
import frontPageReducer_20 from './frontPageSlice_20';
import productsReducer from './productsSlice';
import productGroupsReducer from './productGroupSlice';
import contactFormReducer from './contactFormSlice';


export const store = configureStore({
  reducer: {
    //ocxo: ocxoReducer,
    frontPage: frontPageReducer,
    frontPage_20: frontPageReducer_20,
    products: productsReducer,
    productGroups: productGroupsReducer, 
    contactForm: contactFormReducer, 
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
